import React, {useContext, useRef} from "react";
import {useNavigate} from "react-router-dom";
import UserData from "../store/User/UserData";
import {handleSignOut} from "../util/handleSignOut";
import '../styles/navigation/UserMenu.scss';
import {useOnClickOutside} from "../util/clickOutside";
import {isRoot} from "../util/userControl";

const UserMenu = ({close, userMenuRef}) => {
  const [userData] = useContext(UserData);
  const navigate = useNavigate();
  const isWatchguard = userData?.tenantConfig?.is_watchguard

  let modalRef = useRef(null)

  useOnClickOutside((e) => {
    if (!modalRef.current.contains(e.target) && !userMenuRef.current.contains(e.target)) {
      close(false);
    }
  }, modalRef);

  const getUserMenuConfig = () => {
    if (isWatchguard && !isRoot(userData?.userType)) {
      return [
        { text: userData?.prettyEmail },
      ];
    } else if (userData?.userRegion === "EU") {
      return [
        { text: userData?.prettyEmail },
        { text: "SIGN OUT", function: () => handleSignOut(userData?.tenantConfig?.is_watchguard) }
      ];
    } else {
      return [
        { text: userData?.prettyEmail },
        { text: "RESET PASSWORD", function: () => navigate("/preferences") },
        { text: "SIGN OUT", function: () => handleSignOut(userData?.tenantConfig?.is_watchguard) }
      ];
    }
  };

  return (
    <div className="user-menu modal" ref={modalRef}>
      <div className="user-menu-container modal">
        <div className={"user-icon modal"}>
          <span>{userData?.prettyEmail ? userData?.prettyEmail.substring(0, 1).toUpperCase() : "A"}</span>
        </div>
      </div>
      <div className={"menu-btns"}>
        {getUserMenuConfig(userData).map((opt, i) =>
          <p key={opt.text} className={i === 0 ? "email" : "user-menu-btn"} onClick={opt.function}>
            {opt.text}
          </p>
        )}
      </div>
    </div>
  );
};

export default UserMenu;
